var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, useMediaQuery } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { secondary } from '../../../theme/colors';
import { faintGray } from '../../../theme/palette';
import { getLocalStorageItem, setLocalStorageItem } from '../../../utils/storageHelper';
import { PDIChecPagingAPI, SelectedSavedFilterPicklistAPI, ServiceAdvisorAPI, TechnicianListAPI, VehicleListAPI } from '../services/apiCalls';
import SaveFilterPopUp from './saveFilterPopUp';
import dayjs from 'dayjs';
import { showNotification } from '../../../redux/commonSlice';
import { maxDays, validateFilterDuration } from '../../../utils/utils';
var NewFilterDrawer = function (_ref) {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _getLocalStorageItem4;
    var data = _ref.data, onClose = _ref.onClose;
    var FILTER_APPLY_FLAG = 'APPLIED';
    var dispatch = useAppDispatch();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var organizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.OrganizationId;
    var userOrganizationID = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.Branches[0]) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem4 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem4 === void 0 || (_getLocalStorageItem4 = _getLocalStorageItem4.data) === null || _getLocalStorageItem4 === void 0 || (_getLocalStorageItem4 = _getLocalStorageItem4.Branches[0]) === null || _getLocalStorageItem4 === void 0 ? void 0 : _getLocalStorageItem4.ParentOrganizationId;
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var arrayResponse = [_objectSpread({}, storedSelectedBranch)];
    var crud = useAppSelector(function (state) { return state.crud; });
    var MaxDateRange = getLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION);
    MaxDateRange = MaxDateRange ? Number(MaxDateRange.Value) : maxDays;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: isMobile ? '16px 0px' : 0,
            columnSize: 12,
            mt: IS_DESKTOP ? 10 : 0,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Filters',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary[600]",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function (event, formValues) {
                        onClose({
                            data: formValues ? formValues : null
                        });
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            spacing: 0,
            columnSize: 12,
            gap: 2,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    label: '',
                    getListData: SelectedSavedFilterPicklistAPI,
                    apiRequest: {
                        request: {
                            Key: "PDICheck"
                        }
                    },
                    displayExpr: 'Name',
                    // valueExpr: 'id',
                    placeholder: 'Selected saved filter',
                    columnSize: 12,
                    setFormState: function (formValues, currValue, field) {
                        console.log('currValue', currValue);
                        return _objectSpread({
                            VehicleModel: null,
                            InspectorId: null,
                            TechnicianId: null,
                            Branch: null,
                            StartDate: null,
                            EndtDate: null
                        }, currValue === null || currValue === void 0 ? void 0 : currValue.Value);
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'VehicleModel',
                    label: 'Vehicle model',
                    // options: vehicleArray,
                    getListData: VehicleListAPI,
                    apiRequest: {
                        request: {
                            OrganizationId: organizationId,
                            SystemName: "Product"
                        }
                    },
                    displayExpr: 'DisplayName',
                    valueExpr: 'id',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'InspectorId',
                    label: 'Service advisor',
                    getListData: ServiceAdvisorAPI,
                    apiRequest: {
                        BranchId: organizationId
                    },
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.GivenName) + " " + (option === null || option === void 0 ? void 0 : option.FamilyName); },
                    displayExpr: 'FirstName',
                    valueExpr: 'IdentityId',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'TechnicianId',
                    label: 'Technician name',
                    getListData: TechnicianListAPI,
                    apiRequest: {
                        WorkingOrganizationId: UserOrganization
                    },
                    displayExpr: 'FirstName',
                    valueExpr: 'id',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Branch',
                    label: 'Branch',
                    options: arrayResponse,
                    displayExpr: 'OrganizationName',
                    valueExpr: 'OrganizationId',
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: 12,
                    // spacing: 0, 
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'StartDate',
                            label: 'Date',
                            value: null,
                            columnSize: 12,
                            placeholder: 'From'
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'EndtDate',
                            label: 'To',
                            value: null,
                            columnSize: 12,
                            placeholder: 'To',
                            setFieldProps: function (formValues, currValue, field, formApi) {
                                return {
                                    disabled: !(formValues !== null && formValues !== void 0 && formValues.StartDate),
                                    required: Boolean(formValues === null || formValues === void 0 ? void 0 : formValues.StartDate),
                                    maxDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.StartDate).add(MaxDateRange, 'day'),
                                    minDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.StartDate)
                                };
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            width: {
                xs: '400px'
            },
            justifyContent: 'space-between',
            position: 'fixed',
            bottom: 0,
            right: 0,
            spacing: 0,
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            borderTop: "1px solid ".concat(faintGray),
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Save filter',
                    onClick: function (event, formValues) { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Dialog',
                                        Component: SaveFilterPopUp,
                                        containerProps: {
                                            PaperProps: {
                                                sx: {
                                                    width: '400px',
                                                    borderRadius: 2
                                                }
                                            }
                                        },
                                        componentProps: {
                                            data: formValues
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: 'Reset filters',
                    columnSize: 0,
                    sx: {
                        color: secondary[600],
                        borderColor: 'secondary.600'
                    },
                    setFormState: function (formValues, currValue, field) {
                        return {
                            VehicleModel: null,
                            InspectorId: null,
                            TechnicianId: null,
                            Branch: null,
                            StartDate: null,
                            EndtDate: null
                        };
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Apply',
                    columnSize: 0,
                    // onClick: () => { onClose() }
                    setFormState: function (formValues, currValue, field) { return (setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_APPLY, FILTER_APPLY_FLAG), {}); },
                    onClick: function (event, formValues) { return __awaiter(void 0, void 0, void 0, function () {
                        var _dayjs, res, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (formValues !== null && formValues !== void 0 && formValues.StartDate || formValues !== null && formValues !== void 0 && formValues.EndtDate) {
                                        if (!dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.StartDate).isValid() || !((_dayjs = dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.EndtDate)) !== null && _dayjs !== void 0 && _dayjs.isValid())) {
                                            dispatch(showNotification({
                                                isOpen: true,
                                                message: "Please enter valid dates.",
                                                type: "error"
                                            }));
                                            return [2 /*return*/];
                                        }
                                        if (dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.StartDate).isAfter(dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.EndtDate))) {
                                            dispatch(showNotification({
                                                isOpen: true,
                                                message: "From Date cannot be greater than To Date. Please enter valid dates.",
                                                type: "error"
                                            }));
                                            return [2 /*return*/];
                                        }
                                        if (!validateFilterDuration(dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.StartDate), dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.EndtDate))) {
                                            dispatch(showNotification({
                                                isOpen: true,
                                                message: "The maximum allowed duration for the filter is ".concat(MaxDateRange, " days."),
                                                type: "error"
                                            }));
                                            return [2 /*return*/];
                                        }
                                    }
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    console.log('Filter Values For Paging : ', formValues, data);
                                    return [4 /*yield*/, PDIChecPagingAPI({
                                            request: {
                                                OrganizationId: userOrganizationID,
                                                ParentOrganizationId: parentOrganizationId,
                                                InspectorId: formValues === null || formValues === void 0 ? void 0 : formValues.InspectorId,
                                                TechnicianId: formValues === null || formValues === void 0 ? void 0 : formValues.TechnicianId,
                                                InspectionStartDate: formValues === null || formValues === void 0 ? void 0 : formValues.StartDate,
                                                InspectionEndDate: formValues === null || formValues === void 0 ? void 0 : formValues.EndtDate,
                                                Status: (data === null || data === void 0 ? void 0 : data.Tabs) === 'fail' ? 'Fail' : 'Pass',
                                                take: 10,
                                                skip: 0
                                            }
                                        })];
                                case 2:
                                    res = _a.sent();
                                    if (res !== null && res !== void 0 && res.success) {
                                        onClose({
                                            applyFilter: 'Filter',
                                            data: formValues
                                        });
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.error('Error in PDICheckPagingAPI call:', error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        padding: 3
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data === null || data === void 0 ? void 0 : data.filter,
                        success: true
                    })
                    // getFormAPI={crud[PDICheckKeys?.PDICheckSavedSelectdFilter]?.data?.Value}
                ];
            });
        }); }
        // getFormAPI={crud[PDICheckKeys?.PDICheckSavedSelectdFilter]?.data?.Value}
    })));
};
export default NewFilterDrawer;
